import makeApiCall from '.'

export async function login(payload) {
  return await makeApiCall('/users/login', 'post', payload)
}

export async function getProfile() {
  return await makeApiCall('/users/profile')
}
